import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function render() {
  const buttons = document.querySelectorAll(".c-button");

  ScrollTrigger.matchMedia({
    "(min-width: 1024px)": function () {
      buttons.forEach((el) => {
        let moveButton = gsap.timeline({
          paused: true,
          repeat: -1,
          yoyo: true,
        });
        moveButton.to(el, { rotate: "+=5deg" });
        el.addEventListener("mouseenter", () => {
          moveButton.play();
        });
        el.addEventListener("mouseleave", () => {
          moveButton.pause();
        });
      });
    },

    all: function () {
      buttons.forEach((el) => {
        let showButton = gsap.timeline({
          paused: true,
          scrollTrigger: {
            end: "bottom 90%",
            scroller: ".smooth-scroll",
            start: "bottom 90%",
            trigger: el,
          },
        });

        showButton.to(el.querySelector(".c-button__svg"), {
          duration: 1.2,
          ease: "Circ.easeIn",
          strokeDashoffset: 0,
        });
      });
    },
  });
}
